(function () {
  'use strict';

  const GRID_SELECTOR = '#collection-grid';
  const SOURCE_SELECTOR = '.plp-banners-source';
  const PRODUCT_SELECTOR =
    ':scope > .col:not([data-plp-banner]):not(.bantoa-plp-row), :scope > [data-collection-product]';
  const BP_DESKTOP = 1200;
  const EDITOR_ATTR = 'data-shopify-editor-block';

  const desktopQuery = window.matchMedia('(min-width: ' + BP_DESKTOP + 'px)');

  if (window.plpBannerInjectorTeardown) window.plpBannerInjectorTeardown();

  let teardown = function () {};

  function ownTeardown() {
    teardown();
    teardown = function () {};
  }

  window.plpBannerInjectorTeardown = ownTeardown;

  const templates = Array.prototype.slice.call(
    document.querySelectorAll(SOURCE_SELECTOR + ' [data-plp-banner]')
  );
  if (templates.length === 0) return;

  const positioned = templates
    .map(function (template) {
      let editorAttr = template.getAttribute(EDITOR_ATTR);
      if (editorAttr) {
        template.dataset.editorBlock = editorAttr;
        template.removeAttribute(EDITOR_ATTR);
      } else {
        editorAttr = template.dataset.editorBlock || null;
      }
      return {
        template: template,
        editorAttr: editorAttr,
        after: parseInt(template.dataset.showAfterCards, 10) || 0,
        every: parseInt(template.dataset.repeatEvery, 10) || 0,
      };
    })
    .filter(function (entry) {
      return entry.after > 0;
    })
    .sort(function (a, b) {
      return a.after - b.after;
    });

  if (positioned.length === 0) return;

  function getColumnCount(grid) {
    const classes = grid.className;

    if (desktopQuery.matches) {
      const desktopMatch = classes.match(/row-cols-(?:xl|lg)-(\d+)/);
      return desktopMatch ? parseInt(desktopMatch[1], 10) : 4;
    }

    const mobileMatch = classes.match(/row-cols-(\d+)(?!\w)/);
    return mobileMatch ? parseInt(mobileMatch[1], 10) : 2;
  }

  function bannerColumns(template, cols) {
    let width;

    if (desktopQuery.matches) {
      width = parseInt(template.dataset.desktopSpan, 10) || 1;
    } else {
      const span = template.dataset.mobileSpan;
      if (span === 'hidden') return 0;
      width = span === 'half' ? 1 : cols;
    }

    return width > cols ? cols : width;
  }

  let videoObserver = null;

  function observeVideos(root) {
    const videos = root.querySelectorAll('video');
    if (videos.length === 0) return;

    if (!videoObserver) {
      videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            if (video.networkState === 0 || video.readyState === 0) {
              video.load();
            }
            const attempt = video.play();
            if (attempt && attempt.catch) attempt.catch(function () {});
            videoObserver.unobserve(video);
          });
        },
        { rootMargin: '200px' }
      );
    }

    for (let i = 0; i < videos.length; i++) {
      videoObserver.observe(videos[i]);
    }
  }

  function dropNode(node) {
    if (videoObserver) {
      const videos = node.querySelectorAll('video');
      for (let i = 0; i < videos.length; i++) {
        videoObserver.unobserve(videos[i]);
      }
    }
    node.remove();
  }

  const gridObserver = new MutationObserver(function (mutations) {
    for (let m = 0; m < mutations.length; m++) {
      const added = mutations[m].addedNodes;
      for (let n = 0; n < added.length; n++) {
        const node = added[n];
        if (node.nodeType !== 1) continue;
        if (node.hasAttribute('data-plp-banner')) continue;
        if (node.classList.contains('bantoa-plp-row')) continue;
        debouncedPlace();
        return;
      }
    }
  });

  let observedGrid = null;
  let debounceTimer;

  function debouncedPlace() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(placeBanners, 200);
  }

  function placeBanners() {
    if (!positioned[0].template.isConnected) {
      ownTeardown();
      return;
    }

    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    if (observedGrid !== grid) {
      gridObserver.disconnect();
      gridObserver.observe(grid, { childList: true });
      observedGrid = grid;
    }

    const products = grid.querySelectorAll(PRODUCT_SELECTOR);
    if (products.length === 0) return;

    const existing = {};
    const placed = grid.querySelectorAll(':scope > [data-plp-banner]');
    for (let i = 0; i < placed.length; i++) {
      const key = placed[i].dataset.slotIndex;
      if (existing[key]) dropNode(existing[key]);
      existing[key] = placed[i];
    }

    const cols = getColumnCount(grid);
    const slots = [];
    const taken = {};
    const editorUsed = {};
    let consumed = 0;

    const occurrences = [];
    const cyclic = [];

    for (let i = 0; i < positioned.length; i++) {
      const entry = positioned[i];
      if (entry.every > 0) {
        cyclic.push(entry);
      } else if (entry.after <= products.length) {
        occurrences.push({ entry: entry, after: entry.after });
      }
    }

    let cursor = 0;
    let firstRound = true;
    let exhausted = cyclic.length === 0;

    while (!exhausted) {
      for (let i = 0; i < cyclic.length; i++) {
        const entry = cyclic[i];
        const after = firstRound ? entry.after : cursor + entry.every;
        if (after > products.length) {
          exhausted = true;
          break;
        }
        cursor = after;
        occurrences.push({ entry: entry, after: after });
      }
      firstRound = false;
    }

    occurrences.sort(function (a, b) {
      return a.after - b.after;
    });

    for (let i = 0; i < occurrences.length; i++) {
      const entry = occurrences[i].entry;

      const width = bannerColumns(entry.template, cols);
      if (width === 0) continue;

      let after = occurrences[i].after;
      const column = (after + consumed) % cols;
      if (column + width > cols) after += cols - column;

      if (after > products.length) continue;
      if (taken[after]) continue;

      const bannerKey = entry.template.dataset.bannerKey;
      let editorAttr = null;
      if (entry.editorAttr && !editorUsed[bannerKey]) {
        editorAttr = entry.editorAttr;
        editorUsed[bannerKey] = true;
      }

      taken[after] = true;
      consumed += width;
      slots.push({ position: after, template: entry.template, editorAttr: editorAttr });
    }

    for (let i = 0; i < slots.length; i++) {
      const key = String(slots[i].position);
      const template = slots[i].template;
      const current = existing[key];

      if (current && current.dataset.bannerKey === template.dataset.bannerKey) {
        if (slots[i].editorAttr) {
          current.setAttribute(EDITOR_ATTR, slots[i].editorAttr);
        } else {
          current.removeAttribute(EDITOR_ATTR);
        }
        delete existing[key];
        continue;
      }

      const node = template.cloneNode(true);
      if (slots[i].editorAttr) node.setAttribute(EDITOR_ATTR, slots[i].editorAttr);
      node.dataset.slotIndex = key;
      products[slots[i].position - 1].after(node);
      observeVideos(node);
    }

    for (const leftover in existing) {
      dropNode(existing[leftover]);
    }
  }

  function init() {
    function onSearchComplete() {
      clearTimeout(debounceTimer);
      placeBanners();
    }

    function onBreakpointChange() {
      clearTimeout(debounceTimer);
      placeBanners();
    }

    window.addEventListener('algolia-search-complete', onSearchComplete);
    window.addEventListener('empty-collection-swapped', ownTeardown);
    desktopQuery.addEventListener('change', onBreakpointChange);

    teardown = function () {
      clearTimeout(debounceTimer);
      gridObserver.disconnect();
      observedGrid = null;
      if (videoObserver) {
        videoObserver.disconnect();
        videoObserver = null;
      }
      window.removeEventListener('algolia-search-complete', onSearchComplete);
      window.removeEventListener('empty-collection-swapped', ownTeardown);
      desktopQuery.removeEventListener('change', onBreakpointChange);
    };

    placeBanners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
